import api from './api';

export const listarEstudantes = async () => {
  const response = await api.get('/estudantes');
  return response.data;
};

export const obterEstudante = async (id) => {
  const response = await api.get(`/estudantes/${id}`);
  return response.data;
};

export const criarEstudante = async (estudanteData) => {
  const response = await api.post('/estudantes', estudanteData);
  return response.data;
};

export const obterEstudantePorUsuarioId = async (usuarioId) => {
  const response = await api.get(`/estudantes/usuario/${usuarioId}`);
  return response.data;
};

export const atualizarEstudante = async (id, estudanteData) => {
  const response = await api.put(`/estudantes/${id}`, estudanteData);
  return response.data;
};

export const excluirEstudante = async (id) => {
  const response = await api.delete(`/estudantes/${id}`);
  return response.data;
};